export const RoutePath = {
  MAIN: 'main',
  SESSIONS: 'sessions',
  SIGN_IN: 'sign-in',
  USER: 'user',
  QUESTION_LIST: 'questions-list',
  QUESTION_CARD: 'questions-card',
  USER_GROUPS: 'user-groups',
  USER_GROUP: 'user-group',
  ARTICLES: 'articles-list',
  CREATE_ARTICLE: 'create-article',
  INFO_CARD: "info_card",
  GOALS_LIST: "goals-list",
  CREATE_GOAL: "create-goal",
  AUTHORS: 'authors',
  CREATE_AUTHOR: 'create-author',
  CREATE_INTERACTION: 'create-interaction',
  INTERACTION_LIST: 'interactions',
  ASK_JARED: 'ask-jared',
  ASSESSMENTS: 'assessments',
  SCHEDULED_NOTIFICATIONS: 'scheduled-notifications'
}

export const RoutesConst = {
  MAIN: `/${RoutePath.MAIN}`,
  SIGN_IN: `/${RoutePath.SESSIONS}/${RoutePath.SIGN_IN}`,
  USER_PAGE: `/${RoutePath.MAIN}/${RoutePath.USER}`,
  USER_GROUPS: `/${RoutePath.USER_GROUPS}`,
  USER_GROUP: `/${RoutePath.USER_GROUP}`,
  QUESTION_LIST: `/${RoutePath.QUESTION_LIST}`,
  QUESTION_CARD: `/${RoutePath.QUESTION_CARD}`,
  INFO_CARDS: `/${RoutePath.ARTICLES}`,
  CREATE_INFO_CARD: `/${RoutePath.CREATE_ARTICLE}`,
  GOALS_LIST: `/${RoutePath.GOALS_LIST}`,
  CREATE_GOAL: `/${RoutePath.CREATE_GOAL}`,
  AUTHORS: `/${RoutePath.AUTHORS}`,
  CREATE_AUTHOR: `/${RoutePath.CREATE_AUTHOR}`,
  CREATE_INTERACTION: `/${RoutePath.CREATE_INTERACTION}`,
  INTERACTION_LIST: `/${RoutePath.INTERACTION_LIST}`,
  PROMPT: `/${RoutePath.ASK_JARED}`,
  ASSESSMENTS: `/${RoutePath.ASSESSMENTS}`,
  SCHEDULED_NOTIFICATIONS: `/${RoutePath.SCHEDULED_NOTIFICATIONS}`,
};
